import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ShieldCheck, Timer, Compass } from "lucide-react";

const Feature = ({ Icon, title, sub }) => (
  <div className="cd-card" style={{ padding: 16, display: "flex", gap: 12, alignItems: "flex-start" }}>
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: "var(--cd-primary-soft)",
        color: "var(--cd-primary)",
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
      }}
    >
      <Icon size={18} strokeWidth={1.75} />
    </div>
    <div>
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{title}</div>
      <div style={{ fontSize: 13, color: "var(--cd-muted)", lineHeight: 1.5 }}>{sub}</div>
    </div>
  </div>
);

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="cd-container cd-court-bg cd-fade-in" data-testid="landing-page">
      <section className="cd-hero">
        <div className="cd-hero-visual">
          <span className="cd-hero-badge">
            <Sparkles size={12} /> Personalized in 60 seconds
          </span>
          <h1 className="cd-hero-title">
            Find the paddle<br /> that plays like you.
          </h1>
        </div>

        <h2 className="cd-h2" style={{ marginBottom: 8 }}>
          Answer 7 quick questions.
        </h2>
        <p className="cd-sub" style={{ marginBottom: 20 }}>
          We match you to Club Dink Supply&apos;s best paddles based on your weight,
          grip, style, and priorities. No fluff, no jargon.
        </p>

        <button
          className="cd-btn-primary"
          style={{ width: "100%", marginBottom: 12 }}
          onClick={() => navigate("/quiz")}
          data-testid="landing-start-btn"
        >
          Find my paddle <ArrowRight size={18} />
        </button>
        <div className="cd-micro" style={{ textAlign: "center", marginBottom: 28 }}>
          Free · No signup · Works with your Club Dink cart
        </div>

        <div style={{ display: "grid", gap: 10 }}>
          <Feature Icon={Timer} title="Under a minute" sub="Seven tap-and-go questions. Skip anything you're unsure of." />
          <Feature Icon={Compass} title="Real inventory" sub="Only in-stock paddles at clubdinksupply.com. Alternatives if a match is sold out." />
          <Feature Icon={ShieldCheck} title="One-click cart" sub="Add straight to your Club Dink checkout via secure Shopify link." />
        </div>
      </section>
    </div>
  );
}
